<div id="container">
    <div id="context">  
        <tui-svg
        src="tuiIconMessageSquareLarge"
        class="icon">
      </tui-svg>
    </div>
    <div id="text">{{numComments}}</div>
</div>
